import { defineNuxtPlugin, useSessionCookies } from "#imports";

export default defineNuxtPlugin(() => {
  const sessionCookies = useSessionCookies()

  return {
    provide: {
      sessionCookies
    }
  }
})
